function debounce(e, t = 300) {
  let i;
  return (...s) => {
    clearTimeout(i), i = setTimeout(() => e.apply(this, s), t)
  }
}
if (!customElements.get("speech-search-button")) {
  class e extends HTMLElement {
    constructor() {
      super(), this.recognition = null, this.isListening = !1, this.form = null, this
        .searchInput = null, this.predictiveSearch = this.closest("predictive-search");
      let e = window.navigator.userAgent.toLowerCase();
      "webkitSpeechRecognition" in window && e.indexOf("chrome") > -1 && window.chrome && -1 === e
        .indexOf("edg/") ? (this.init(), this.bindEvents()) : this.predictiveSearch && this
        .predictiveSearch.classList.add("speech-search--failed")
    }
    bindEvents() {
      this.recognition.addEventListener("result", debounce(e => {
        if (e.results) {
          let t = e.results[0][0].transcript;
          this.searchInput.value = t, "combobox" === this.searchInput.getAttribute("role") ?
            this.searchInput.dispatchEvent(new Event("input")) : this.form.submit()
        }
      }, 300)), this.recognition.addEventListener("audiostart", () => {
        this.isListening = !0, this.classList.add("search__speech-listening")
      }), this.recognition.addEventListener("audioend", () => {
        this.isListening = !1, this.classList.remove("search__speech-listening")
      }), this.addEventListener("click", this.toggleListen), this.addEventListener("keydown",
        e => {
          ("Space" === e.code || "Enter" === e.code) && this.toggleListen(e)
        })
    }
    init() {
      this.classList.remove("hidden"), this.recognition = new window.webkitSpeechRecognition, this
        .recognition.continuous = !1, this.recognition.interimResults = !1, this.form = this
        .closest("form"), this.searchInput = this.form.querySelector(".js-search-input"), this
        .predictiveSearch && this.predictiveSearch.classList.add("speech-search--enabled")
    }
    toggleListen(e) {
      e.preventDefault(), this.isListening ? this.recognition.stop() : this.recognition.start()
    }
  }
  customElements.define("speech-search-button", e)
}
